module.exports = __webpack_public_path__ + "static/media/9(1).f72fb436.jpg";